import type { ReactNode } from "react";

function textoDoRotulo(rotulo: ReactNode): string {
  return typeof rotulo === "string" ? rotulo.trim() : "";
}

export function rotuloJaTemAsterisco(rotulo: ReactNode): boolean {
  return /\*$/.test(textoDoRotulo(rotulo));
}

interface RotuloObrigatorioProps {
  rotulo: ReactNode;
  obrigatorio?: boolean;
}

export function RotuloObrigatorio({ rotulo, obrigatorio = false }: RotuloObrigatorioProps) {
  const temAsterisco = rotuloJaTemAsterisco(rotulo);
  if (!obrigatorio && !temAsterisco) return <>{rotulo}</>;

  const rotuloExibido = temAsterisco
    ? textoDoRotulo(rotulo).replace(/\s*\*$/, "")
    : rotulo;

  return (
    <>
      {rotuloExibido}
      <span className="campoObrigatorioAsterisco" aria-hidden="true"> *</span>
    </>
  );
}
